<template>
  <div class="app-container">
    <CrudTable entity="ExternalApiUser" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'username',
        { field: 'domainName', label: 'common.domain' },
        { field: 'storeName', label: 'store.name' },
        { field: 'workshopName', label: 'common.workshop' }
      ]
    };
  },
  methods: {
    generateSummary({ username, domainName, workshopName }) {
      const name = domainName || workshopName;
      return `${username}, ${name}`;
    }
  }
};
</script>
